import React, { useEffect, useState } from 'react';
import {
  Button, Container, Grid, Paper, TextField, Typography, Rating,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import axiosinstance from '../../../../api/axiosinstance';
import securedInstance from '../../../../api/securedInstance';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import WelcomeMenus from '../../WelcomeMenus';

const UpdateTestimonialForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useSelector((s) => s.auth);
  const isAdmin = user?.role_id === 1;

  const [formData, setFormData] = useState({
    candidate_name: '',
    job_role: '',
    feedback: '',
    rating: 5,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axiosinstance.get(`/api/testimonials/${id}`)
      .then((res) => {
        const t = Array.isArray(res.data) ? res.data[0] : res.data;
        if (t) {
          setFormData({
            candidate_name: t.candidate_name || '',
            job_role:     t.job_role     || '',
            feedback:       t.feedback       || '',
            rating:         t.rating         || 5,
          });
        }
        setLoading(false);
      })
      .catch(() => { toast.error('Failed to load testimonial'); setLoading(false); });
  }, [id]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await securedInstance.put(`/api/testimonials/${id}`, formData);
      toast.success('Testimonial updated');
      navigate('/auth/allTestimonials');
    } catch {
      toast.error('Update failed');
    }
  };

  if (!isAdmin) return <><h2>Admin only</h2><WelcomeMenus /></>;
  if (loading) return <p style={{ padding: 40 }}>Loading…</p>;

  return (
    <Container maxWidth="sm" sx={{ display: 'flex', mt: 4 }}>
      <Paper elevation={2} sx={{ padding: '28px', width: '100%' }}>
        <form onSubmit={handleSubmit}>
          <Typography variant="h6" gutterBottom>Edit Testimonial</Typography>
          <Button onClick={() => navigate(-1)} sx={{ mb: 2 }}>Back</Button>

          <Grid container spacing={2} sx={{ border: '1px solid rgba(0,0,0,0.125)', padding: '20px' }}>
            <Grid item xs={12}>
              <TextField
                label="Student Name" name="candidate_name" fullWidth required
                value={formData.candidate_name} onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Role / Program" name="job_role" fullWidth
                value={formData.job_role} onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Feedback" name="feedback" fullWidth required multiline rows={4}
                value={formData.feedback} onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography component="legend" sx={{ fontSize: 14, mb: 0.5, color: 'text.secondary' }}>
                Rating
              </Typography>
              <Rating
                value={Number(formData.rating)}
                onChange={(_, val) => setFormData({ ...formData, rating: val })}
                size="large"
              />
            </Grid>
            <Grid item xs={12}>
              <Button type="submit" variant="contained" fullWidth style={{ backgroundColor: '#3251A3' }}>
                Save Changes
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </Container>
  );
};

export default UpdateTestimonialForm;
